/**
 * @generated SignedSource<<99faaf60603573dd1317b8b9043cd033>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedVideoComponent_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponentVideo_viewer">;
  readonly " $fragmentType": "HpSharedVideoComponent_viewer";
};
export type HpSharedVideoComponent_viewer$key = {
  readonly " $data"?: HpSharedVideoComponent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedVideoComponent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedVideoComponentVideo_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "6b8bc3bf26f23cd701657c9ee25de609";

export default node;
